const BCHQ_MAGIC = [0x42, 0x43, 0x48, 0x51]; // BCHQ
const BCHI_MAGIC = [0x42, 0x43, 0x48, 0x49]; // BCHI

export const isBchiTemplate = (bytes) => {
  if (!bytes || bytes.length < BCHI_MAGIC.length) {
    return false;
  }
  return BCHI_MAGIC.every((value, index) => bytes[index] === value);
};

export const isBchqTemplate = (bytes) => {
  if (!bytes || bytes.length < BCHQ_MAGIC.length) {
    return false;
  }
  return BCHQ_MAGIC.every((value, index) => bytes[index] === value);
};

export const bdbToUint8Array = (bdb) => {
  if (!bdb) {
    return new Uint8Array(0);
  }
  if (bdb instanceof Uint8Array) {
    return bdb;
  }
  if (Array.isArray(bdb)) {
    return Uint8Array.from(bdb, (value) => (value < 0 ? value + 256 : value) & 0xff);
  }
  return new Uint8Array(bdb);
};
